var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('t-form-item',{attrs:{"label":_vm.schema.text || _vm.schema.id,"prop":_vm.schema.propertyName,"required":_vm.schema.required,"important":_vm.schema.important}},[_c('t-color-picker',{attrs:{"value":_vm.value,"size":_vm.schema.size,"disabled":_vm.schema.readOnly},on:{"input":_vm.change}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }